import { useEffect } from 'react'

// More than one bar can show at once (cached Ionic pages, the tour map modal), so the class is shared:
// count the bars showing and take it off only when the last one goes.
let barsShowing = 0

/** Holds the `has-audio-player` body class (the page's reserved bottom padding) while `visible`. */
export const useAudioPlayerSpace = (visible: boolean): void => {
	useEffect(() => {
		if (!visible) {
			return
		}

		barsShowing++
		document.body.classList.add('has-audio-player')

		return () => {
			barsShowing--
			if (barsShowing <= 0) {
				barsShowing = 0
				document.body.classList.remove('has-audio-player')
			}
		}
	}, [visible])
}
